// Libs
import classNames from 'classnames/bind';
import { Flex, Table, Text, View } from '@instructure/ui';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
// Components, Layouts, Pages
// Others
import { IModule } from '~/utils/interface/course';
import { DATE_FORMAT } from '~/utils/constants/common';
// Styles, images, icons
import styles from './CourseTable.module.scss';
import './CourseTable.scss';
import { icons } from '~/assets';

type Props = {
  courses: IModule[];
  onClick: (module: IModule) => void;
};

const cx = classNames.bind(styles);

const CourseTable = (props: Props) => {
  //#region Destructuring Props
  const { courses, onClick } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/home', 'common/base', 'common/course']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <>
      <div className={cx('desktop')}>
        <Table>
          <Table.Body>
            {courses.map((course, index) => {
              const isDisable = course.date ? moment(course.date).isAfter(moment()) : true;
              return (
                <Table.Row
                  key={index}
                  onClick={() => !isDisable && onClick(course)}
                  classID={isDisable ? 'disableItem' : undefined}
                >
                  <Table.Cell>
                    <View as='div' className={cx('courseDateContainer')}>
                      <Flex direction='row' alignItems='center' gap='xxx-small'>
                        <img
                          src={icons.commonIconCalendarDay}
                          alt={t('common_alt_img', { ns: 'common/base' })}
                          className={cx('iconTable')}
                        />
                        <Text>{moment.utc(course.date).local().format(DATE_FORMAT.DATE)}</Text>
                      </Flex>
                    </View>
                  </Table.Cell>

                  <Table.Cell>
                    <Flex direction='column'>
                      <div className={cx('truncate')}>
                        <Text variant='content'>{course.name}</Text>
                      </div>

                      <div className={cx('truncate')}>
                        <Text variant='content'>{course.teacher?.name}</Text>
                      </div>
                    </Flex>
                  </Table.Cell>

                  <Table.Cell>
                    <View as={'div'} className={cx('courseTimeContainer')}>
                      <Flex direction='row' alignItems='center' gap='xxx-small' justifyItems='end'>
                        <img
                          src={icons.commonIconClock}
                          alt={t('common_alt_img', { ns: 'common/base' })}
                          className={cx('iconTable')}
                        />
                        <Text variant='content'>{moment.utc(course.date).local().format(DATE_FORMAT.TIME)}</Text>
                      </Flex>
                    </View>
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>

      <div className={cx('mobile')}>
        <Table>
          <Table.Body>
            {courses.map((course, index) => {
              const isDisable = course.date ? moment(course.date).isAfter(moment()) : true;
              return (
                <div
                  key={index}
                  className={cx('courseTableMobile', isDisable && 'disableItem')}
                  onClick={() => !isDisable && onClick(course)}
                >
                  <Flex direction='column' gap='small'>
                    <Text variant='content'>{course.name}</Text>

                    <Flex alignItems='center' gap='small'>
                      <img
                        src={icons.commonIconCalendarDay}
                        alt={t('common_alt_img', { ns: 'common/base' })}
                        className={cx('iconTable')}
                      />
                      <Text variant='content'>{moment.utc(course.date).local().format(DATE_FORMAT.DATE)}</Text>
                    </Flex>

                    <Flex alignItems='center' gap='small'>
                      <img
                        src={icons.commonIconClock}
                        alt={t('common_alt_img', { ns: 'common/base' })}
                        className={cx('iconTable')}
                      />
                      <Text variant='content'>{moment.utc(course.date).local().format(DATE_FORMAT.TIME)}</Text>
                    </Flex>

                    <Flex alignItems='center' gap='small'>
                      <img
                        src={icons.commonIconTeacher}
                        alt={t('common_alt_img', { ns: 'common/base' })}
                        className={cx('userIcon')}
                      />
                      <Text variant='content'>{course.teacher?.name}</Text>
                    </Flex>
                  </Flex>
                </div>
              );
            })}
          </Table.Body>
        </Table>
      </div>
    </>
  );
};

export default CourseTable;
